import Service, { type Registry as Services, service } from '@ember/service';
import { DIMENSIONS } from 'lumen/utils/constants/pi-constant-values';

export default class PsSelectionsService extends Service {
  @service declare router: Services['router'];

  // By default, the loss score is calculated based on the number of hotels with issues
  // When a hotel is selected, the loss score is calculated based on the number of shops
  get isHotelSelected(): boolean {
    // @ts-expect-error: Object is possibly 'null'.
    const { activeFilters } = this.router.currentRoute.queryParams;
    if (activeFilters === undefined) {
      return false;
    }

    // @ts-expect-error: Argument of type '{} | null' is not assignable to parameter of type 'string'.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return JSON.parse(activeFilters).some((filter: string) =>
      filter.startsWith(DIMENSIONS.HOTEL),
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'ps-selections': PsSelectionsService;
  }
}
